import ph_rokcet from "../../../assets/icons/ph_rocket-thin.svg";
import marketq_research from "../../../assets/icons/marketeq_research.svg";
import arctincons_settings from "../../../assets/icons/arcticons_settings.svg";
import arctincons_top from "../../../assets/icons/arcticons_top.svg";

export const setupData = [
    {
        icon: ph_rokcet,
        title: "Старт проекта",
        items: [
            "• Определение сроков проведения проекта и критерии успешности",
            "• Демонстрация",
            "• Подписание NDA",
            "• Определение сроков проведения проекта и критериев его успешности"
        ],
        duration: "от 1 дня",
        items_style: "xl:w-[208px]",
        title_style: "xl:w-[227px]"
    },
    {
        icon: marketq_research,
        
        title: "Обследование и проектирование",
        items: [
            "• Сбор информации",
            "• Заполнение анкет",
            "• Подготовка архитектуры решения",
            "• Формирование плана-графика работ"
        ],
        duration: "от 2-х дней",
        items_style: "xl:w-[205px]",
        title_style: "xl:w-[227px]"
    },
    {
        icon: arctincons_settings,
        
        title: "Старт пилота",
        items: [
            "• Выделение оборудования",
            "• Установка агентов",
            "• Сбор данных AI модель",
            "• Обучение сотрудников"
        ],
        duration: "от 7 дней",
        items_style: "xl:w-[205px]",
        title_style: "xl:w-[227px]"
    },
    {
        icon: arctincons_top,
        
        title: "Презентация результатов",
        items: [
            "• Финальная презентация результатов пилота",
            "• Подготовка бюджетной оценки",
            "• Подготовка технико-экономического обоснования (ТЭО)"
        ],
        duration: "от 2-х дней",
        items_style: "xl:w-[205px]",
        title_style: "xl:w-[227px]"
    }
]; 